import { marketsConfig } from './config';
import {
  ensureTrailingSlash,
  getLanguagePrefixForMarket,
  removeLeadingSlash,
} from './link-helper';
import { AlternativeLink, Language, Market } from './types';

export const fullAlternativeLinks = (links: AlternativeLink[]) =>
  links.map((l) => {
    const domain = ensureTrailingSlash(localeBaseUrl(l.locale));
    const href = removeLeadingSlash(l.href);

    return {
      locale: l.locale,
      href: ensureTrailingSlash(domain + href),
    };
  });

export const localeBaseUrl = (locale: string, domainOnly = false): string => {
  const elements = locale.split('-');
  const lang = elements[0] as Language;
  const market = elements[1] as Market;

  const marketLanguageConfig = marketsConfig[market]?.languages.find(
    (l) => l.code === lang,
  );

  if (!marketLanguageConfig || !marketLanguageConfig.domain) {
    throw new Error(
      `[ERROR] missing marketLanguageConfig for current market and language`,
    );
  }

  const langPrefix = getLanguagePrefixForMarket(market, lang);

  if (langPrefix && !domainOnly) {
    return ensureTrailingSlash(marketLanguageConfig.domain + langPrefix);
  }

  return marketLanguageConfig.domain;
};
